const HelpButtonBlue = ({ ...props }) => {
  return (
    <svg width="35" height="35" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="20" cy="20" r="20" fill="white"/>
      <path d="M19 24H21V26H19V24ZM20 10C14.48 10 10 14.48 10 20C10 25.52 14.48 30 20 30C25.52 30 30 25.52 30 20C30 14.48 25.52 10 20 10ZM20 28C15.59 28 12 24.41 12 20C12 15.59 15.59 12 20 12C24.41 12 28 15.59 28 20C28 24.41 24.41 28 20 28ZM20 14C17.79 14 16 15.79 16 18H18C18 16.9 18.9 16 20 16C21.1 16 22 16.9 22 18C22 20 19 19.75 19 23H21C21 20.75 24 20.5 24 18C24 15.79 22.21 14 20 14Z" fill="#2F528F"/>
    </svg> 
  );
};
    
export default HelpButtonBlue;